<template>
	<div class="main bgwhite" v-title data-title="零部件权益" style="overflow-x: hidden;">
		<iHeader :message="msg"></iHeader>
		<div style="width: 100%; margin: 0px auto; background:#323364;">
			<img src="../../assets/index/vip1.jpg" alt="" style="width: 1920px;height: 800px;">
		</div>

		<div class="flexRow justBetween barprebox mt25">
			<div class="barprebox bgwhite" style="width: 1150px;">
				<h2 style="margin-top: 20px;margin-bottom:40px">
					<span class="iconL"><i class="el-icon-caret-left"></i><i class="el-icon-caret-left"></i><i class="el-icon-caret-left"></i></span>
					<span class="ml18">会员权益</span>
					<span class="iconL"><i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i></span>
				</h2>
				<template>
					<el-table :header-cell-style="{background:'#f9d687',color:'#000000','font-size':'18px','font-bold':'bold','text-align': 'center'}"
					 :cell-style="{'text-align':'center',color:'#000000','font-family': '微软雅黑'}" :data="tableData" border style="width:100%;margin: 0px atuo;overflow-x: hidden;">
						<el-table-column prop="tqname" label="特权" width="240">
						</el-table-column>
						<el-table-column prop="tgname" label="平台推广期" width="240">
						</el-table-column>
						<el-table-column prop="hyname" label="企业会员" width="440">
						</el-table-column>
						<el-table-column prop="vipname" label="超级会员" width="229">
						</el-table-column>
					</el-table>
				</template>
			</div>
		</div>
		<div style="width: 100%; margin: 0px auto; background:#323364; margin-top: 100px;">
			<img src="../../assets/index/vip2.jpg" alt="" style="width: 1920px;height:500px;">
		</div>
		<h2 style="margin-top: 60px;margin-bottom:60px"><span class="iconL"><i class="el-icon-caret-left"></i><i class="el-icon-caret-left"></i><i class="el-icon-caret-left"></i></span>
					<span class="ml18">常见问题</span>
					<span class="iconL"><i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i><i class="el-icon-caret-right"></i></span></h2>
		<div class="qsdiv">
			<el-row class="pd20" style="padding: 50px 20px">
				<el-col :span="12">
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i> 会员费用支付后可以退款吗 <i class="el-icon-arrow-right"></i></el-link>
					</li>
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i>会员费用可以申请发票吗<i class="el-icon-arrow-right"></i></el-link>
					</li>
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i>会员支持哪些支付方式 <i class="el-icon-arrow-right"></i></el-link>
					</li>
				</el-col>
				<el-col :span="12">
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i>开通会员后如何查看会员权益 <i class="el-icon-arrow-right"></i></el-link>
					</li>
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i>会员可以续费吗 <i class="el-icon-arrow-right"></i></el-link>
					</li>
					<li>
						<el-link class="qshover" :underline="false"><i class="iconli"></i>会员可以升级吗 <i class="el-icon-arrow-right"></i></el-link>
					</li>
				</el-col>
			</el-row>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
		},
		data() {
			return {
				msg: "vipmember",
				tableData: [{
					tqname: '销售提成',
					tgname: '不收取费用',
					hyname: '收取10%',
					vipname: '×'
				}, {
					tqname: '品牌展示',
					tgname: '无',
					hyname: '√',
					vipname: '√'
				}, {
					tqname: '企业联系方式',
					tgname: '无',
					hyname: '×',
					vipname: '√'
				}, {
					tqname: '主动营销',
					tgname: '无',
					hyname: '每月获取10次联系方式',
					vipname: '无限制'
				}, {
					tqname: '小程序',
					tgname: '赠送非独立版',
					hyname: '非独立版本，集成在沐风工业云内',
					vipname: '独立版小程序'
				}, {
					tqname: '广告位',
					tgname: '赠送广告位',
					hyname: '',
					vipname: ''
				}, {
					tqname: '排名',
					tgname: '无',
					hyname: '×',
					vipname: '优先'
				}, {
					tqname: '展示',
					tgname: '无',
					hyname: '×',
					vipname: '加V认证（等级）'
				}, {
					tqname: '专属客服',
					tgname: '无',
					hyname: '×',
					vipname: '√'
				}, {
					tqname: 'API',
					tgname: '无',
					hyname: '√',
					vipname: '√'
				}, {
					tqname: '3D预览',
					tgname: '√',
					hyname: '√',
					vipname: '√'
				}, {
					tqname: '微信公众号推广',
					tgname: '免费推广1次/月',
					hyname: '9折优惠',
					vipname: '5折优惠'
				}, {
					tqname: '价格',
					tgname: '0 元',
					hyname: '免费版',
					vipname: '2980元/年',
				}]
			};
		},
		created() {
			this.goods_id = this.$route.query.goodsid;
		},
		methods: {

		}
	}
</script>

<style scoped>
	.qsdiv {
		width: 1150px;
		margin: 0px auto;
		border: 1px dashed #CCCCCC;
	}

	.qsdiv li {
		line-height: 35px;
	}

	.qshover.el-link.el-link--default {
		color: #000000;
		font-family: '微软雅黑';
		font-size: 14px;
		text-align: left;
		display: block;
		width: 60%;
		margin: 0px auto;
	}

	.qshover .el-icon-arrow-right {
		line-height: 35px;
		float: right;
	}

	.qshover.el-link.el-link--default:hover {
		color: #005dbe;
	}

	.iconli {
		width: 5px;
		height: 5px;
		border-radius: 5px;
		background-color: #000000;
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}

	.el-icon-caret-left,
	.el-icon-caret-right {
		width: 12px;
	}

	.iconL {
		width: 50px;
		display: inline-block;
	}

	.ml18 {
		margin-left:18px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/vipmember.vue